import { PlannedDeliveryWindow } from '@bringg/dashboard-sdk';

export const readMaxTaskCapacity = (pdw: PlannedDeliveryWindow | null | undefined): number | null =>
	pdw?.data?.max_task_capacity ?? null;

export const withMaxTaskCapacityPayload = <T extends object>(pdw: T): T => {
	const { max_task_capacity, ...rest } = pdw as T & {
		max_task_capacity?: number | null;
		data?: Record<string, unknown> | null;
	};

	return {
		...rest,
		// Merge into the existing data so only max_task_capacity is overridden — other data keys are kept.
		...(max_task_capacity != null ? { data: { ...rest.data, max_task_capacity } } : {})
	} as T;
};
